import { render, staticRenderFns } from "./roles-and-permissions-details.html?vue&type=template&id=1ba2cbfe&scoped=true&external"
import script from "./roles-and-permissions-details.js?vue&type=script&lang=js&external"
export * from "./roles-and-permissions-details.js?vue&type=script&lang=js&external"
import style0 from "./roles-and-permissions-details.scss?vue&type=style&index=0&id=1ba2cbfe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2cbfe",
  null
  
)

export default component.exports